import { Form } from '../../services/form';
import { NotificationService } from '../../notification/swal/notification.service';
import { LoginModel } from '../../models/login.model';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import Auth from '../../helpers/auth';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent extends Form implements OnInit {

  user: LoginModel = new LoginModel();
  showAppleDownloadStoreLink: boolean;
  showGoogleDownloadStoreLink: boolean;

  constructor(private authService: AuthService, private router: Router, private notificationService: NotificationService) {
    super();
  }

  ngOnInit() {
    if (Auth.userIsAuthenticated()) {
      this.loginUserAndGetImage();
    } else {
      const appleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const androidDevice = /Android/.test(navigator.userAgent);
      const browserDevice = /Safari|Chrome|Firefox/.test(navigator.userAgent);

      if (browserDevice && appleDevice) {
        this.showAppleDownloadStoreLink = true;
      } else if (androidDevice) {
        this.showAppleDownloadStoreLink = false;
        this.showGoogleDownloadStoreLink = false;
      } else if (browserDevice) {
        this.showAppleDownloadStoreLink = true;
        this.showGoogleDownloadStoreLink = true;
      }

      localStorage.clear();
    }
  }

  signIn() {
    if (this.getFormStatus()) {
      this.signInValidFields();
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }

  private signInValidFields() {
    this.authService.signIn(this.user)
      .then(() => {
          this.loginUserAndGetImage();
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private loginUserAndGetImage() {
    this.router.navigate(['general/home']);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/login/login.component.ts